import { GLServiceBase } from "vue-glcommonui";
import { HelperServiceInterface } from "@/services";
import {
  CancelJoinAsHelperResponse,
  GetSessionStatusResponse,
  HelperExitResponse,
  HelperRequestTeachingResponse,
  JoinSessionAsHelperResponse,
  TeacherAcceptHelperResponse,
  TeacherDenyHelperResponse,
  TeacherRemoveHelperResponse,
  TeacherToggleHelperVideo,
} from "./model";
import { cloneDeep } from "lodash";
import { FetchSessionDtoResModel } from "@/services";
import { store } from "@/store";
import { UserRequestModel } from "@/ws/models";
import { MODULES, vuexName } from "@/store/utils";

export const mapSessionOneToOneForHelper = (model: FetchSessionDtoResModel) => {
  const cloned = cloneDeep(model);
  if (!cloned.data) {
    return cloned;
  }
  cloned.data.oneToOneWithAnotherTeacherStudentId = cloned.data.oneAndOneDto?.studentId;
  if (model.data?.settings) {
    cloned.data.settings = cloneDeep(model.data.settings);
    const helperOneOneChannel = cloned.data.settings?.channels?.helperOneOne;
    if (helperOneOneChannel) {
      cloned.data.settings.channels.oneOne = helperOneOneChannel;
    }
  }
  if (cloned.data.oneAndOneDto && cloned.data.helperOneAndOneDto) {
    cloned.data.oneAndOneDto.studentId = cloned.data.helperOneAndOneDto.studentId;
  }
  cloned.data.oneAndOneDto = cloned.data.helperOneAndOneDto;
  return cloned;
};
export const mapSessionOneToOneForTeacher = (model: FetchSessionDtoResModel) => {
  const cloned = cloneDeep(model);
  if (!cloned.data) {
    return cloned;
  }
  cloned.data.oneToOneWithAnotherTeacherStudentId = cloned.data.helperOneAndOneDto?.studentId || "";
  return cloned;
};
class HelperServiceClass extends GLServiceBase<any, any> implements HelperServiceInterface {
  get userRequestModel(): UserRequestModel {
    return {
      userId: store.getters[vuexName(MODULES.AUTH.GETTERS.GET_LOGIN_INFO)]?.profile?.sub,
      sessionId: store.getters[vuexName(MODULES.CLASS_TEACHING.GETTERS.GET_SESSION_ID)],
    };
  }
  serviceRoute = { prefix: "connect/v1" };
  getSessionStatus(groupId: string): Promise<GetSessionStatusResponse> {
    return this.get("helper/session-status", { groupId });
  }
  joinSessionAsHelper(groupId: string, deviceId: string): Promise<JoinSessionAsHelperResponse> {
    return this.get("helper/request-join-session", { groupId, deviceId });
  }
  cancelJoinAsHelperRequest(groupId: string): Promise<CancelJoinAsHelperResponse> {
    return this.update(`helper/cancel-request?groupId=${groupId}`);
  }
  fetchSessionDataAsHelper(groupId: string, deviceId = ""): Promise<FetchSessionDtoResModel> {
    return this.get("helper/session-data", { groupId, deviceId }).then((res) => mapSessionOneToOneForHelper(res as FetchSessionDtoResModel));
  }
  exitSession(): Promise<HelperExitResponse> {
    return this.update("helper/exit-session");
  }
  teacherAcceptHelper(helperId: string, helperName: string, deviceId: string): Promise<TeacherAcceptHelperResponse> {
    const { sessionId } = this.userRequestModel;
    return this.create("teacher/accept-helper", { helperId, helperName, deviceId, sessionId });
  }
  teacherDenyHelper(helperId: string): Promise<TeacherDenyHelperResponse> {
    const { sessionId } = this.userRequestModel;
    return this.create(`teacher/deny-helper/${helperId}/session/${sessionId}`);
  }
  teacherToggleHelperVideo(show: boolean): Promise<TeacherToggleHelperVideo> {
    const { sessionId } = this.userRequestModel;
    return this.create(`teacher/toggle-helper-video/${show}/session/${sessionId}`);
  }
  teacherRemoveHelper(helperId: string): Promise<TeacherRemoveHelperResponse> {
    const { sessionId } = this.userRequestModel;
    return this.create("teacher/remove-helper", { helperId, sessionId });
  }
  takeTeacherRole(): Promise<HelperRequestTeachingResponse> {
    const { sessionId } = this.userRequestModel;
    return this.create(`helper/take-teacher-role/session/${sessionId}`);
  }
  helperSetOneOne(sessionId: string, studentId?: string | null): Promise<any> {
    const url = studentId ? `helper/one-one/${sessionId}/${studentId}` : `helper/one-one/${sessionId}`;
    return this.create(url);
  }
}

export const HelperService = new HelperServiceClass();
